import React from "react";
import EditCell from "../EditableCell";
import { ACCESSORS } from "../../../../constants";
import { Wrapper } from "./styled";

const Amount = ({ handleChange, row, defVal }) => {
  return (
    <Wrapper>
      <EditCell handleChange={handleChange} row={row} name={ACCESSORS[2]} defVal={defVal} />
    </Wrapper>
  );
};

export default Amount;
